import { ImageLoaderProps } from 'next/image';
import { MediaResizerRoute } from './entities/MediaResizerRoute';
import { getMediaResizerUrl } from './utils/getMediaResizerUrl';

const mediaResizerRoutes: MediaResizerRoute[] = [
  {
    sourceOrigins: ['https://media.appnebula.co', 'https://media-funnels.askzodi.com'],
    resizerOrigin: process.env.NEXT_PUBLIC_MEDIA_RESIZER_URL ?? '',
  },
  {
    sourceOrigins: ['https://media.asknebula.com'],
    resizerOrigin: 'https://media-optimized.asknebula.com',
  },
  {
    sourceOrigins: ['https://cms-media.asknebula.com'],
    resizerOrigin: 'https://cms-media-optimized.asknebula.com',
  },
  {
    sourceOrigins: [
      'https://astrocrmmedia.obrio.net',
      'https://astrocrm-media.obrio.net',
      'https://astrologers-media.askzodi.com',
    ],
    resizerOrigin: 'https://astrocrm-media-optimized.obrio.net',
  },
];

const mediaResizerLoader = (props: ImageLoaderProps) => {
  const resizerUrl = getMediaResizerUrl(props, mediaResizerRoutes);
  const imageUrl = resizerUrl ?? props.src;

  return imageUrl;
};

export default mediaResizerLoader;
